import React from 'react';
import CancelFilled from '../../Icons/CancelFilled';
export default function Chip(theme) {
    return {
        MuiChip: {
            defaultProps: {
                deleteIcon: /*#__PURE__*/ React.createElement(CancelFilled, null)
            },
            styleOverrides: {
                colorDefault: {
                    '&.MuiChip-sizeMedium > .MuiChip-avatar, .MuiChip-avatarSmall': {
                        color: theme.palette.text.secondary
                    }
                },
                avatarColorInfo: {
                    color: theme.palette.info.contrastText,
                    backgroundColor: theme.palette.info.dark
                },
                avatarColorSuccess: {
                    color: theme.palette.success.contrastText,
                    backgroundColor: theme.palette.success.dark
                },
                avatarColorWarning: {
                    color: theme.palette.warning.contrastText,
                    backgroundColor: theme.palette.warning.dark
                },
                avatarColorError: {
                    color: theme.palette.error.contrastText,
                    backgroundColor: theme.palette.error.dark
                },
                avatarColorUnderwriting: {
                    color: theme.palette.underwriting.contrastText,
                    backgroundColor: theme.palette.underwriting.dark
                }
            }
        }
    };
}
